import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=6bb786f2&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb786f2')) {
      api.createRecord('6bb786f2', component.options)
    } else {
      api.reload('6bb786f2', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=6bb786f2&", function () {
      api.rerender('6bb786f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85s25qlC5ou5P/JS/comp/childrenage.vue"
export default component.exports